import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

export function getOrderDetail(params) {
  return axios.request({
    url: `${urlObj.wss}wss-order/order/getOrderDetail?orderCode=${params.id}`,
    method: 'get'
  })
}

// 发货
export function orderDelivery(params) {
  return axios.request({
    url: `${urlObj.wss}wss-order/order/orderDelivery`,
    method: 'put',
    params
  })
}
// 物流信息
export function getlogisticsdata(params) {
  return axios.request({
    url: `${urlObj.wss}wss-order/afterSale/listLogistics/${params}`,
    // url:`http://192.168.0.125:5000/wss-order/afterSale/listLogistics/${params}`,
    method: 'get',
  })
}

// 收货
export function orderTakeDelivery(params) {
  return axios.request({
    url: `${urlObj.wss}wss-order/order/orderTakeDelivery`,
    method: 'put',
    params
  })
}
